const sizes = {
  header: {
    headerHeight: "72px",
    paddingHeader: "20px",
  },
  button: {
    rounded: {
      sm: {
        width: 124,
        height: 40,
        borderRadius: 30,
      },
      lg: {
        width: 400,
        height: 50,
        borderRadius: 50,
      },
    },
    circle: {
      width: 40,
      height: 40,
      borderRadius: 50,
    },
  },
  images: {
    logo_sm: {
      width: 268,
      height: 40,
    },
    logo_sm_mobile: {
      width: 192,
      height: 30,
    },
    logo_bg: {
      width: 533,
      height: 65,
    },
  },
};
export default sizes;
